import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f38ba43a&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&module=styleGrid&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&module=styleSpacer&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleGrid"] = (style0.locals || style0)
this["styleSpacer"] = (style1.locals || style1)
this["$style"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports